module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<tr index=\"")
    ; __append(escapeFn( index ))
    ; __append("\">\n	")
    ;  Util.each (plugin.columns, function (cell) { 
    ; __append("\n	<td>")
    ; __append( plugin.makeCell(item, cell) )
    ; __append("</td>\n	")
    ;  }) 
    ; __append("\n</tr>\n")
  }
  return __output.join("");

}